import { Lead } from '../../entities/lead/model/types';
import { formatDate } from './utils';

function formatPhoneForClipboard(phone?: string | null): string {
  const digits = (phone ?? '').replace(/\D/g, '');

  if (!digits) {
    return 'Не указан';
  }

  let normalized = digits;

  if (digits.length === 10) {
    normalized = `8${digits}`;
  } else if (digits.length === 11 && digits.startsWith('7')) {
    normalized = `8${digits.slice(1)}`;
  }

  if (!/^8\d{10}$/.test(normalized)) {
    return phone?.trim() || 'Не указан';
  }

  return `${normalized[0]} ${normalized.slice(1, 4)} ${normalized.slice(4, 7)} ${normalized.slice(7)}`;
}

type LeadClipboardFields = Pick<Lead, 'title' | 'phone' | 'destination' | 'city' | 'sending' | 'note'>;

export function buildLeadClipboardText(lead: LeadClipboardFields): string {
  const note = lead.note?.trim() ?? '';

  return [
    `1. ${lead.title?.trim() || 'Без названия'}`,
    `2. ${formatPhoneForClipboard(lead.phone)}`,
    `3. Город назначения: ${lead.destination?.trim() || 'Не указано'}`,
    `4. Город выезда: ${lead.city?.trim() || 'Не указан'}`,
    `5. Дата выезда: ${lead.sending ? formatDate(lead.sending) : 'Не указана'}`,
    '',
    'Примечание:',
    '',
    note,
  ].join('\n');
}
